import { ErrorAlert } from '@/components/_ui/ErrorAlert'
import { Separator } from '@/components/_ui/Separator'
import { Skeleton } from '@/components/_ui/Skeleton'
import { socialIcons } from '@/components/Footer/MainFooter'
import T, { useTranslate } from '@/components/Helpers/Translate'
import useGlobalStore from '@/store/useGlobalStore'
import Image from 'next/image'

type Props = {
  setIsCountrySelectorOpen: (value: boolean) => void
}

export const MobileDrawerFooter = ({ setIsCountrySelectorOpen }: Props) => {
  const {
    cms: { header },
    app: { language, alpha2 },
  } = useGlobalStore()
  const { translate } = useTranslate()

  const changeCountryElement = () => (
    <div className="flex space-x-2 p-3 text-sm">
      <Image
        className="rounded-md"
        height={30}
        width={30}
        src={`/flags/${alpha2}.svg`}
        alt={translate(alpha2)}
      />
      <span>
        <T>{alpha2}</T> - <T>{language}</T>
      </span>
      <span>|</span>
      <button
        onClick={() => setIsCountrySelectorOpen(true)}
        className="cursor-pointer underline"
      >
        <T>change</T>
      </button>
    </div>
  )

  if (!header) return null
  if (header === 'loading') {
    return (
      <div className="flex flex-col space-y-2 p-5">
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
      </div>
    )
  }

  if (header === 'error') {
    return (
      <div className="bg-sky-50 p-5">
        {changeCountryElement()}
        <Separator className="my-3" />
        <div className="m-5">
          <ErrorAlert
            error={{
              error: {
                code: 500,
                message: 'Error loading footer content.',
              },
            }}
          />
        </div>
      </div>
    )
  }

  return (
    <div className="bg-sky-50 p-5">
      {changeCountryElement()}
      <Separator className="my-3" />

      {/* <div className="text-sm"> // TODO: Missing in cosmic
        {header.mobileDrawerFooterData.map((item) => (
          <div key={item.item.href} className="p-2">
            <a href={item.item.href} rel="noreferrer" target="_blank">
              <span>{item.item.displayText}</span>
            </a>
          </div>
        ))}
      </div> */}

      <div className="mt-11 flex gap-6 pb-10">
        {socialIcons.map(({ alt, src, href, className }) => (
          <a
            href={href}
            key={alt}
            className="flex h-[24px]"
            rel="noreferrer"
            target="_blank"
          >
            <Image
              alt={alt}
              src={src}
              width={24}
              height={24}
              className={`max-h-full hover:scale-125 ${className}`}
            />
          </a>
        ))}
      </div>
    </div>
  )
}
